import { Offer, OfferEntryTable, SaleOption } from '../types';

import { getColorFromOfferStatus } from './helpers';

export function offerEntryTableTransformer(offer: Offer): OfferEntryTable {
  return {
    id: offer.id,
    status: {
      name: offer.status,
      color: getColorFromOfferStatus(offer.status),
    },
    company: {
      id: offer.company.id,
      name: offer.company.name,
    },
    opportunity: offer.opportunity.id,
    createdAt: offer.created_at,
  };
}
